import React, { useState } from 'react'
import { CloudUploadOutlined, DeleteOutlined, LinkOutlined, LoadingOutlined } from '@ant-design/icons'
import { Spin, Upload, notification } from 'antd'
import PropTypes from 'prop-types'
import { fetchPresignedUrl, uploadFileToS3WithPresignedUrl } from '~actions'

import styles from './HeroImageUploader.module.css'

const { Dragger } = Upload

const HeroImageUploader = ({
  handleUpload,
  logoUrl
}) => {
  const [uploadStatus, setUploadStatus] = useState(false)
  const [fileList, setFileList] = useState([])

  const handleImageDelete = (event) => {
    handleUpload('')
    setFileList([])
    event.preventDefault()
  }

  const handleChange = async ({ file }) => {
    if (fileList.length > 1) {
      notification.warning({ message: 'You can only upload one file!' })
      return
    }
    const isImage = file.type.startsWith('image/')
    const isSVG = file.type === 'image/svg+xml'
    if (!isImage && !isSVG) {
      notification.warning({ message: 'You can only upload image files (JPG, PNG, JPEG, SVG)' })
    }
    try {
      setUploadStatus(true)
      const fileName = file?.name.split('.')
      const formattedFile = `${fileName[0]}_${new Date().getTime()}.${fileName[1]}`
      const response = await fetchPresignedUrl({
        fileName: `event-engine/${formattedFile}`,
        fileType: file.type
      })
      const { presignedPutUrl, url } = response
      await uploadFileToS3WithPresignedUrl(presignedPutUrl, file)
      setUploadStatus(false)
      handleUpload(url)
      setFileList([file])
    } catch (error) {
      console.error(error)
      setUploadStatus(false)
    }
  }

  return (
    <div className={styles.wrapper}>
      {logoUrl ? (
        <div className={styles.previewContainer}>
          {uploadStatus && (
            <div className={styles.spinnerOverlay}>
              <Spin indicator={<LoadingOutlined spin />} size="large" />
            </div>
          )}
          <div className={styles.previewBox}>
            <img alt="Hero preview" className={styles.previewImage} src={logoUrl} />
            <div className={styles.previewActions}>
              <a
                className={styles.previewLink}
                href={logoUrl}
                rel="noreferrer"
                target="_blank"
              >
                <LinkOutlined style={{ marginRight: 4 }} />
                View full image
              </a>
              <button className={styles.deleteBtn} onClick={handleImageDelete} type="button">
                <DeleteOutlined style={{ marginRight: 4 }} />
                Remove
              </button>
            </div>
          </div>
        </div>
      ) : (
        <div className={styles.dragger}>
          {uploadStatus && (
            <div className={styles.spinnerOverlay}>
              <Spin indicator={<LoadingOutlined spin />} size="large" />
            </div>
          )}
          <Dragger
            accept="image/*,image/svg+xml"
            beforeUpload={() => false}
            fileList={fileList}
            maxCount={1}
            onChange={handleChange}
            onRemove={() => setFileList([])}
            showUploadList={false}
          >
            <CloudUploadOutlined className={styles.uploadIcon} />
            <p className={styles.uploadTitle}>Click or drag an image here</p>
            <p className={styles.uploadHint}>Supports JPG, PNG, JPEG, SVG · Max 1 file</p>
          </Dragger>
        </div>
      )}
    </div>
  )
}

HeroImageUploader.propTypes = {
  handleUpload: PropTypes.func,
  logoUrl: PropTypes.string
}

export default HeroImageUploader
